import type { DashboardDemoMode } from "@/lib/evaluation-dashboard-context"

/** Demo maturity presets for the Surveys dashboard (mock until API). */
export type EvaluationDashboardScenario = "onboarding" | "midway" | "advanced"

export const EVALUATION_DASHBOARD_SCENARIOS: {
  id: EvaluationDashboardScenario
  label: string
  description: string
}[] = [
  {
    id: "onboarding",
    label: "First term setup",
    description: "No terms configured. Start from term setup.",
  },
  {
    id: "midway",
    label: "Mid term",
    description: "Schedules set. Live collection starting across courses.",
  },
  {
    id: "advanced",
    label: "Full term",
    description: "Mixed stages across current, last, and upcoming terms.",
  },
]

const LEGACY_SCENARIO_MAP: Record<string, EvaluationDashboardScenario> = {
  "brand-new": "onboarding",
  "setup-started": "onboarding",
  "ready-to-launch": "midway",
  "first-live": "midway",
  "first-closed": "midway",
  growing: "advanced",
  mature: "advanced",
  "mature-optimized": "advanced",
}

export function normalizeEvaluationDashboardScenario(
  value: unknown,
): EvaluationDashboardScenario | null {
  if (isEvaluationDashboardScenario(value)) return value
  if (typeof value === "string" && value in LEGACY_SCENARIO_MAP) {
    return LEGACY_SCENARIO_MAP[value]
  }
  return null
}

export function evaluationDashboardScenarioLabel(
  scenario: EvaluationDashboardScenario,
): string {
  return (
    EVALUATION_DASHBOARD_SCENARIOS.find(option => option.id === scenario)?.label ??
    "Full term"
  )
}

export function scenarioToDemoMode(
  scenario: EvaluationDashboardScenario,
): DashboardDemoMode {
  if (scenario === "onboarding") return "empty"
  if (scenario === "midway") return "stateFirstLive"
  return null
}

export function demoModeToScenario(demo: DashboardDemoMode): EvaluationDashboardScenario {
  if (demo === "empty") return "onboarding"
  if (
    demo === "caseMidway" ||
    demo === "case5" ||
    demo === "case6" ||
    demo === "stateSetup" ||
    demo === "stateReady" ||
    demo === "stateFirstLive"
  ) {
    return "midway"
  }
  return "advanced"
}

export function isEvaluationDashboardScenario(
  value: unknown,
): value is EvaluationDashboardScenario {
  return value === "onboarding" || value === "midway" || value === "advanced"
}
